module.exports = __webpack_public_path__ + "img/exclusive.c0f4603.webp";